<div class="w-100 h-100">
    <div class="row" style="padding-top: 25px;padding-bottom: 25px;">
        <div class="col-md-12">
            <label class="header_text mb-3">
                {{ isEditMode ? $t('shared.editRegulation') : $t('shared.addNewRegulation') }}
            </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-10">
            <div class="card card_layout">
                <div class="card-body">
                    <div v-if="isActiveLocked" class="alert alert-warning">
                        {{ $t('shared.regulationCannotEditActive') }}
                    </div>
                    <div class="form-group mb-3" v-if="!isEditMode">
                        <label>{{ $t('shared.regulationCategory') }}</label>
                        <select class="form-control" v-model.number="category">
                            <option :value="1">{{ $t('shared.regulationCategorySmsTemplate') }}</option>
                            <option :value="2">{{ $t('shared.regulationCategorySenderName') }}</option>
                        </select>
                    </div>
                    <div class="form-group mb-3" v-if="isEditMode">
                        <label>{{ $t('shared.regulationCategory') }}</label>
                        <input type="text" class="form-control" readonly :value="category === 1 ? $t('shared.regulationCategorySmsTemplate').toString() : $t('shared.regulationCategorySenderName').toString()" />
                    </div>
                    <div class="form-group mb-3">
                        <label>{{ $t('shared.regulationStatus') }}</label>
                        <select class="form-control" v-model.number="status" :disabled="isActiveLocked">
                            <option :value="0">{{ $t('shared.regulationStatusDraft') }}</option>
                            <option :value="1">{{ $t('shared.regulationStatusActive') }}</option>
                        </select>
                    </div>
                    <div class="form-group mb-3">
                        <label>{{ $t('shared.regulationPolicies') }} <span class="text-danger">*</span></label>
                        <textarea class="form-control" rows="8" v-model="regulationsText"
                                  :disabled="isActiveLocked"
                                  :placeholder="$t('shared.regulationPoliciesPlaceholder')"></textarea>
                    </div>
                    <div class="form-group mb-3" v-if="isEditMode">
                        <label>{{ $t('shared.regulationAiPrompt') }}</label>
                        <textarea class="form-control" rows="8" readonly v-model="aiPromptText"></textarea>
                    </div>
                    <div class="form-row">
                        <div class="col-auto">
                            <button type="button" class="btn btn-primary" @click="save"
                                    :disabled="!isValid || isActiveLocked">
                                {{ $t('shared.save') }}
                            </button>
                        </div>
                        <div class="col-auto">
                            <router-link :to="{ name: 'RegulationsManagement' }" class="btn btn-outline-secondary">
                                {{ $t('shared.cancel') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
